import { useQuery } from '@tanstack/react-query';

import useApi from '@/hooks/useApi/useApi';
import { queryKeys } from '@/lib/queryKeys';
import { TaskCategory } from '@/types/types';

export const useTaskCategories = () => {
  const { axiosInstance } = useApi();
  return useQuery<TaskCategory[]>({
    queryKey: queryKeys.taskCategories.all.queryKey,
    queryFn: async () => {
      const { data } = await axiosInstance.get<TaskCategory[]>('/api/v1/task_categories');
      return data;
    },
  });
};

export default useTaskCategories;
